import {PROGRESSIVES, BIFOCAL, READING} from 'constants/wizard/prescriptionType';

import type {
    PrescriptionDataType,
    PrescriptionValidationRulesType,
} from 'reducers/wizard/prescriptionData/prescriptionDataType';

/**
 * Checks current usage available for add field
 * @param {string} usage current usage
 * @return {boolean} - flag
 */
export const isUsageWithAddField = (usage: string): boolean =>
    [PROGRESSIVES, BIFOCAL, READING].includes(usage);

export const rules: PrescriptionValidationRulesType = {
    axi_od: (value: string, fields: PrescriptionDataType): string => {
        if (fields.cyl_od && Boolean(parseFloat(fields.cyl_od)) && (!value || value === 'None')) {
            return 'Please select';
        }
        return '';
    },

    axi_os: (value: string, fields: PrescriptionDataType): string => {
        if (fields.cyl_os && Boolean(parseFloat(fields.cyl_os)) && (!value || value === 'None')) {
            return 'Please select';
        }
        return '';
    },
    cyl_od: () => '',
    cyl_os: () => '',
    add_od: (value: string, fields: PrescriptionDataType): string => {
        if (isUsageWithAddField(fields.usage) && (!value || value === 'None')) {
            return 'Please select';
        }
        return '';
    },
    add_os: (value: string, fields: PrescriptionDataType): string => {
        if (isUsageWithAddField(fields.usage) && (!value || value === 'None')) {
            return 'Please select';
        }
        return '';
    },
    usage: () => '',
    sph_od: () => '',
    sph_os: () => '',
    pd_left: (value: string, fields: PrescriptionDataType): string => {
        if (fields.isMultiPd.value && (!value || value === 'None')) {
            return 'Please select';
        }
        return '';
    },
    pd_right: (value: string, fields: PrescriptionDataType): string => {
        if (fields.isMultiPd.value && (!value || value === 'None')) {
            return 'Please select';
        }
        return '';
    },
    isMultiPd: () => '',
};

export const addRules: PrescriptionValidationRulesType = {
    add_od: (value: string): string => (value.length === 0 ? 'Please select' : 'success'),
    add_os: (value: string): string => (value.length === 0 ? 'Please select' : 'success'),
};
